"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactRenderToString = require("preact-render-to-string");

var _topicService = require("../services/topicService");

var _contentType = require("@insided/shared/utils/contentType");

var _utils = require("./utils");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _publish = _interopRequireDefault(require("../../../../../components/tracker/publish"));

var _Modal = require("@insided/shared/uikit/Modal");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _urlGenerator = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/urlGenerator"));

var _FromReply = _interopRequireDefault(require("@insided/deprecated-control/ideas/auto-replies/FromReply"));

var _ToReply = _interopRequireDefault(require("@insided/deprecated-control/ideas/auto-replies/ToReply"));

var _logger = require("@insided/shared/services/logger");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MergeIdeaModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MergeIdeaModal, _Component);

  var _super = _createSuper(MergeIdeaModal);

  function MergeIdeaModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MergeIdeaModal);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _utils.fetchPhrases)([{
                module: 'Common',
                key: 'reply.idea.status.changed'
              }, {
                module: 'Control',
                key: 'idea.merge.from'
              }, {
                module: 'Control',
                key: 'idea.merge.from.votes'
              }, {
                module: 'Control',
                key: 'idea.merge.to'
              }, {
                module: 'Control',
                key: 'idea.merge.to.votes'
              }]);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validate", function () {
      var errors = {};
      var _this$state = _this.state,
          toIdeaUrl = _this$state.toIdeaUrl,
          acknowledgement = _this$state.acknowledgement,
          nextFromIdeaStatus = _this$state.nextFromIdeaStatus;

      if (!toIdeaUrl) {
        Object.assign(errors, {
          toIdeaUrl: 'Please add a topic URL'
        });
      }

      if (!acknowledgement) {
        Object.assign(errors, {
          acknowledgement: 'Please confirm that you understand the ramifications of this action'
        });
      }

      if (!nextFromIdeaStatus) {
        Object.assign(errors, {
          nextFromIdeaStatus: 'Please select an ideation status'
        });
      }

      if (Object.keys(errors).length > 0) {
        _this.setState({
          isSubmitting: false
        });

        _this.setState({
          errors: errors
        });

        throw new Error();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMergeIdea", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props, contentType, fromIdea, onShowAlert, _this$state2, toIdea, nextFromIdeaStatus;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, contentType = _this$props.contentType, fromIdea = _this$props.fromIdea, onShowAlert = _this$props.onShowAlert;
              _this$state2 = _this.state, toIdea = _this$state2.toIdea, nextFromIdeaStatus = _this$state2.nextFromIdeaStatus;
              _context2.prev = 2;

              _this.setState({
                isSubmitting: true
              });

              _this.validate();

              _context2.next = 7;
              return (0, _topicService.mergeVotes)(contentType, fromIdea.id, toIdea === null || toIdea === void 0 ? void 0 : toIdea.id);

            case 7:
              _publish.default.trackEvent('userevent', {
                type: 'Idea votes merged',
                ideaId: fromIdea.id,
                toIdeaId: toIdea === null || toIdea === void 0 ? void 0 : toIdea.id
              });

              _context2.next = 10;
              return (0, _topicService.assignIdeaStatus)(contentType, fromIdea.id, nextFromIdeaStatus === null || nextFromIdeaStatus === void 0 ? void 0 : nextFromIdeaStatus.id);

            case 10:
              _publish.default.trackEvent('userevent', {
                type: 'Idea status assigned',
                ideaId: fromIdea.id,
                ideaStatusId: nextFromIdeaStatus === null || nextFromIdeaStatus === void 0 ? void 0 : nextFromIdeaStatus.id
              });

              _context2.next = 13;
              return _this.sendAutoReplies();

            case 13:
              onShowAlert('success', 'The idea has been merged successfully');
              window.location.reload();
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](2);

              _logger.logger.error(_context2.t0, {
                component: 'MergeIdeaModal',
                action: 'mergeIdea'
              });

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 17]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendAutoReplies", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props2, fromIdeaStatus, fromIdea, contentType, _this$state3, toIdea, nextFromIdeaStatus, fromReply, toReply;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props2 = _this.props, fromIdeaStatus = _this$props2.fromIdeaStatus, fromIdea = _this$props2.fromIdea, contentType = _this$props2.contentType;
              _this$state3 = _this.state, toIdea = _this$state3.toIdea, nextFromIdeaStatus = _this$state3.nextFromIdeaStatus;
              fromReply = (0, _preactRenderToString.render)((0, _preact.h)(_FromReply.default, {
                oldIdeationStatus: fromIdeaStatus,
                newIdeationStatus: nextFromIdeaStatus,
                toIdeaUrl: _this.ideaUrl(toIdea)
              }));
              toReply = (0, _preactRenderToString.render)((0, _preact.h)(_ToReply.default, {
                fromIdeaUrl: _this.ideaUrl(fromIdea)
              }));
              _context3.next = 6;
              return (0, _topicService.replyToTopic)(contentType, fromIdea.id, fromReply);

            case 6:
              _context3.next = 8;
              return (0, _topicService.replyToTopic)(contentType, toIdea === null || toIdea === void 0 ? void 0 : toIdea.id, toReply);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ideaUrl", function (idea) {
      return "".concat((0, _globals.default)('communityUrl')).concat((0, _urlGenerator.default)('ideas', idea.title, idea.publicId));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUrlInput", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
        var _e$target, toIdeaUrl, topic, toIdea, data, _error, errorMessage;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                toIdeaUrl = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
                _context4.next = 4;
                return (0, _topicService.getTopicByUrl)(toIdeaUrl);

              case 4:
                topic = _context4.sent;
                toIdea = {
                  id: topic.privateId,
                  title: topic.topictitle,
                  publicId: topic.threadid
                };

                if (!(topic.contenttype !== _contentType.CONTENT_TYPE_IDEA)) {
                  _context4.next = 8;
                  break;
                }

                throw new SyntaxError('Please enter an idea URL');

              case 8:
                _context4.next = 10;
                return (0, _topicService.getTopicCardFromUrl)(toIdeaUrl);

              case 10:
                data = _context4.sent;

                _this.setState(function (_ref5) {
                  var errors = _ref5.errors;
                  return {
                    toIdea: toIdea,
                    toIdeaUrl: toIdeaUrl,
                    topicCard: data.html,
                    errors: _objectSpread(_objectSpread({}, errors), {
                      toIdeaUrl: ''
                    })
                  };
                });

                _context4.next = 19;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](0);
                _error = _context4.t0;
                errorMessage = _error instanceof SyntaxError ? _error.message : 'Please enter a valid URL';

                _this.setState(function (_ref6) {
                  var errors = _ref6.errors;
                  return {
                    toIdeaUrl: '',
                    topicCard: '',
                    errors: _objectSpread(_objectSpread({}, errors), {
                      toIdeaUrl: errorMessage
                    })
                  };
                });

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 14]]);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _this.state = {
      toIdea: null,
      toIdeaUrl: '',
      topicCard: '',
      nextFromIdeaStatus: null,
      acknowledgement: false,
      errors: {
        toIdeaUrl: '',
        acknowledgement: ''
      },
      isSubmitting: false
    };
    _this.onMergeIdea = _this.onMergeIdea.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(MergeIdeaModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          isOpen = _this$props3.isOpen,
          ideaStatuses = _this$props3.ideaStatuses,
          _onClose = _this$props3.onClose;
      var _this$state4 = this.state,
          toIdeaUrl = _this$state4.toIdeaUrl,
          topicCard = _this$state4.topicCard,
          toIdea = _this$state4.toIdea,
          acknowledgement = _this$state4.acknowledgement,
          errors = _this$state4.errors,
          isSubmitting = _this$state4.isSubmitting,
          nextFromIdeaStatus = _this$state4.nextFromIdeaStatus;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Merge idea",
        onClose: function onClose() {
          return _onClose();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
        className: "merge-idea-modal"
      }, (0, _preact.h)(_InputGroup.default, {
        value: toIdeaUrl,
        title: "Merge current idea into",
        type: "text",
        placeholder: "Enter a topic URL",
        onChange: this.onUrlInput,
        error: errors.toIdeaUrl || undefined
      }), toIdeaUrl && toIdea && topicCard && (0, _preact.h)("div", {
        className: "topic-card-preview",
        dangerouslySetInnerHTML: {
          __html: topicCard
        }
      }), (0, _preact.h)(_InputGroup.default, {
        title: "Ideation status after merging",
        error: errors.nextFromIdeaStatus || undefined,
        customInput: (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          triggerClass: "dropdown-wrapper",
          trigger: (0, _preact.h)(_Button.default, {
            icon: "arrowDropdown",
            title: nextFromIdeaStatus ? nextFromIdeaStatus.name : 'Select an ideation status'
          }),
          items: ideaStatuses.filter(function (ideaStatus) {
            return ideaStatus.visible;
          }).map(function (ideaStatus) {
            return {
              title: ideaStatus.name,
              value: ideaStatus.id,
              onClick: function onClick() {
                _this2.setState({
                  nextFromIdeaStatus: ideaStatus
                });
              }
            };
          })
        })
      }), (0, _preact.h)(_InputGroup.default, {
        inline: true,
        formGroupClasses: "merge-idea-modal__acknowledgement",
        title: (0, _preact.h)("span", null, "By merging this idea, votes in the current idea will be transferred to the other idea.", ' ', (0, _preact.h)("strong", null, "This cannot be undone.")),
        type: "checkbox",
        onChangeCheckbox: function onChangeCheckbox(event) {
          return _this2.setState(function (_ref7) {
            var errors = _ref7.errors;
            return {
              acknowledgement: event.target.checked,
              errors: _objectSpread(_objectSpread({}, errors), {}, {
                acknowledgement: event.target.checked ? '' : 'Please confirm that you understand the ramifications of this action'
              })
            };
          });
        },
        checked: acknowledgement,
        error: errors.acknowledgement || undefined
      }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        disabled: isSubmitting,
        isLoading: isSubmitting,
        title: "Merge",
        variant: "primary",
        onClick: this.onMergeIdea,
        className: "qa-merge-idea"
      }), (0, _preact.h)(_Button.default, {
        disabled: isSubmitting,
        title: "Cancel",
        onClick: function onClick() {
          return _onClose();
        }
      })));
    }
  }]);
  return MergeIdeaModal;
}(_preact.Component);

var _default = MergeIdeaModal;
exports.default = _default;